'use client';

import Link from 'next/link';
import { Country } from '@/types';
import { useLanguage } from '@/contexts/LanguageContext';
import { getFlagImageUrl } from '@/lib/flags';

interface CountryFilterProps {
  countries: Country[];
  counts: Record<string, number>;
}

export default function CountryFilter({ countries, counts }: CountryFilterProps) {
  const { t } = useLanguage();

  return (
    <section id="countries" className="py-20 bg-gray-50 dark:bg-[#0f172a] transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] dark:text-white mb-4">{t('countries.title')}</h3>
          <p className="text-lg text-gray-600 dark:text-gray-400">{t('countries.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {countries.map((country) => (
            <Link
              key={country.code}
              href={`/country/${country.code}`}
              className="bg-white dark:bg-[#1e293b] rounded-xl p-8 card-hover cursor-pointer text-center border-2 border-transparent hover:border-[#d4a574] transition-colors duration-300"
            >
              <img src={getFlagImageUrl(country.code, 'lg')} alt={country.name} className="w-16 h-auto mx-auto mb-4 rounded shadow" />
              <h4 className="text-2xl font-bold text-[#1e3a5f] dark:text-white mb-2">{t(`country.${country.code}`)}</h4>
              <p className="text-[#d4a574] font-semibold text-lg">{counts[country.code] || 0} Providers</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
